var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19ZM13.376 7.58397C13.6057 7.23933 14.0714 7.1462 14.416 7.37596L17.416 9.37596C17.7607 9.60573 17.8538 10.0714 17.624 10.416C17.3943 10.7607 16.9286 10.8538 16.584 10.624L13.584 8.62404C13.2393 8.39427 13.1462 7.92862 13.376 7.58397ZM9.58397 7.37596C9.92862 7.1462 10.3943 7.23933 10.624 7.58397C10.8538 7.92862 10.7607 8.39427 10.416 8.62404L7.41603 10.624C7.07138 10.8538 6.60573 10.7607 6.37596 10.416C6.1462 10.0714 6.23933 9.60573 6.58397 9.37596L9.58397 7.37596Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYawn);
export default __webpack_public_path__ + "static/media/yawn.872c3b3a325b596828e51c430c8d42b2.svg";
export { ForwardRef as ReactComponent };